export interface Event {
  name: string;
  lastDate: string;
  maxInvites: number;
}

export interface CreateEventRequest {
  name: string;
  lastDate: string;
  maxInvites: number;
}

export interface UpdateEventRequest {
  name: string;
  lastDate: string;
  maxInvites: number;
}

export interface CheckInGuestRequest {
  clientCode: string;
  documentType: string;
  document: string;
}

export interface ClientEvent {
  clientCode: string;
  nit: string;
  clientName: string;
  guests: Guest[];
}

export interface Guest {
  guestName: string;
  documentType: string;
  document: string;
  position: string;
  status: string;
  clientName: string | null;
  clientCode: string | null;
}

export function EventActions() {
  function infoEvent(
    name: string,
    lastDate: string,
    maxInvites: number
  ): Event {
    return {
      name: name,
      lastDate: lastDate,
      maxInvites: maxInvites,
    };
  }

  function createEventRequest(
    name: string,
    lastDate: string,
    maxInvites: number
  ): CreateEventRequest {
    return {
      name: name,
      lastDate: lastDate,
      maxInvites: maxInvites,
    };
  }

  function updateEventRequest(
    name: string,
    lastDate: string,
    maxInvites: number
  ): UpdateEventRequest {
    return {
      name: name,
      lastDate: lastDate,
      maxInvites: maxInvites,
    };
  }

  function checkInGuestRequest(
    clientCode: string,
    documentType: string,
    document: string
  ): CheckInGuestRequest {
    return {
      clientCode: clientCode,
      documentType: documentType,
      document: document,
    };
  }

  function infoGuest(
    guestName: string,
    documentType: string,
    document: string,
    position: string,
    status: string,
    clientName: string | null,
    clientCode: string | null
  ): Guest {
    return {
      guestName: guestName,
      documentType: documentType,
      document: document,
      position: position,
      status: status,
      clientName: clientName,
      clientCode: clientCode,
    };
  }

  function clientEvent(
    clientCode: string,
    nit: string,
    clientName: string,
    guests: Guest[]
  ): ClientEvent {
    return {
      clientCode: clientCode,
      nit: nit,
      clientName: clientName,
      guests: guests,
    };
  }

  function deserialize(object: string): Event {
    const parseResponse = JSON.parse(JSON.stringify(object));

    return infoEvent(
      parseResponse.name,
      parseResponse.lastDate,
      parseResponse.maxInvites
    );
    // return parseResponse.map((event: Event) => {
    //   return infoEvent(
    //     event.name,
    //     event.lastDate,
    //     event.maxInvites
    //   );
    // });
  }

  function deserializeGuest(
    guests: Guest[],
    clientCode: string,
    clientName: string
  ): Guest[] {
    return guests.map((guest: Guest) => {
      return infoGuest(
        guest.guestName,
        guest.documentType,
        guest.document,
        guest.position,
        guest.status,
        clientName,
        clientCode
      );
    });
  }

  function deserializeClientEvent(object: string): ClientEvent[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((client: ClientEvent) => {
      return clientEvent(
        client.clientCode,
        client.nit,
        client.clientName,
        deserializeGuest(client.guests, client.clientCode, client.clientName)
      );
    });
  }

  return {
    infoEvent,
    clientEvent,
    createEventRequest,
    updateEventRequest,
    checkInGuestRequest,
    infoGuest,
    deserialize,
    deserializeGuest,
    deserializeClientEvent,
  };
}
